export default __webpack_public_path__ + "static/media/borderBG.da0d2638.png";